import { Button, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';

import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { Iconic } from '@/commons/iconic';
import ListPage from '@/components/Table';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { PATH_DASHBOARD } from '@/routes/paths';
import { translates } from '@/utils/translate';
import { useOrdersContext } from '@/hooks/useOrderContext';
import { useOrder } from '@/hooks/useOrder';
import { OrderHistory, Roles } from '@/utils';
import { useRole } from '@/hooks/useRole';
import { useCompanyCategory } from '@/hooks/useCompanyCategory';
import { useEffect } from 'react';
import { ListActionsOrders } from '../actions-list';
import { Order } from '../types';
import { TABLE_HEAD_ORDERS } from '../utils/constants';
import { OrderStatus } from './cookingPanel';

const queryFilter = (dataOrder: any) => {
  if (!dataOrder) return null;
  const response = dataOrder?.data?.filter(
    (item: { status: OrderStatus }) => item.status === OrderStatus.Closed
  );
  return { ...dataOrder, data: response };
};

export default function ClosedOrdersPage() {
  const navigate_orders: any = {
    view: PATH_DASHBOARD.orders.view,
    edit: PATH_DASHBOARD.orders.edit,
    openOrders: PATH_DASHBOARD.orders.open_orders
  };
  const { isFoodCompany } = useCompanyCategory();

  const title = 'Orders';
  const links = [
    { name: translates.dashboard, href: PATH_DASHBOARD.root },
    { name: translates.orders, href: PATH_DASHBOARD.orders.list },
    { name: translates.list },
  ];
  const { authorized: authorizedWithAtm } = useRole([Roles.ADMIN, Roles.ATM, Roles.SUPER_ADMIN]);
  const { handleActualOrders } = useOrdersContext();
  const { data, isLoading, refetch, paginator, setPaginator } = useOrder({
    filter: true,
    query: OrderHistory.CLOSED,
  });

  const filterOrder = queryFilter(data);
  const { isOpen } = useCashRegisterContext();

  useEffect(() => {
    if (isOpen) {
      handleActualOrders();
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <>
      <Helmet>
        <title>
          {' '}
          {import.meta.env.VITE_TITLE_BUSINESS}: {title} List
        </title>
      </Helmet>

      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={`${translates.list} ${title} `}
          links={links}
          action={[
            <Button
              component={RouterLink}
              to={PATH_DASHBOARD.orders.new}
              variant="contained"
              startIcon={<Iconic icon="eva:plus-fill" />}
            >
              {`${translates.new} ${translates.order} `}
            </Button>,
          ]}
        />

        <ListPage<Order, string>
          data={filterOrder?.data}
          navigateHandle={navigate_orders}
          actions={
            authorizedWithAtm
              ? (props: any) => <ListActionsOrders {...props} isActual />
              : undefined
          }
          isLoading={isLoading}
          dataStruct={TABLE_HEAD_ORDERS(isFoodCompany)}
          paginator={{ refresh: refetch, setPaginator, paginator }}
        />
      </Container>
    </>
  );
}
